export enum ProductType {
	Primary = "primary",
	Technician = "addon_technician",
	Sparky = "addon_lucky"
}
